import { render, staticRenderFns } from "./pay-add-or-update.vue?vue&type=template&id=90a53138"
import script from "./pay-add-or-update.vue?vue&type=script&lang=js"
export * from "./pay-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./pay-add-or-update.vue?vue&type=style&index=0&id=90a53138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports